/**
 * RT MAROC - Catalogue Pieces Carrosserie
 * Application SPA legere pour theme Shopify
 * Marques -> Modeles -> Produits
 */

(function () {
  'use strict';

  // ============================================
  // CONFIG & STATE
  // ============================================

  var container = document.getElementById('catalogue-app');
  if (!container) return;

  var API_URL = (container.getAttribute('data-api-url') || '').replace(/\/+$/, '');
  var GROQ_KEY = container.getAttribute('data-groq-key') || '';
  var root = document.getElementById('catalogue-root');
  var loading = document.getElementById('catalogue-loading');

  // Theme editor brand logos (override API logos)
  var themeLogos = {};
  try {
    var logoScript = document.getElementById('catalogue-brand-logos');
    if (logoScript) themeLogos = JSON.parse(logoScript.textContent) || {};
  } catch (e) { themeLogos = {}; }

  var CACHE_TTL = 30 * 60 * 1000; // 30 minutes
  var CACHE_PREFIX = 'rtcat_';
  var MANIFEST_KEY = CACHE_PREFIX + 'manifest_version';
  var PRODUCTS_PER_BATCH = 20; // Progressive rendering: products per batch

  var state = {
    view: 'brands',      // brands | models | products
    brand: null,
    model: null,
    brands: [],
    models: [],
    products: [],
    logos: {},
    images: {},
    navigation: null,
    search: '',
    activeCategory: 'all',
    manifestVersion: null,
    productsShown: PRODUCTS_PER_BATCH, // How many products currently visible
    productsLoaded: false // Flag to distinguish "not loaded" from "loaded but empty"
  };

  var eventsInitialized = false; // Prevent duplicate event listeners

  // Voice search: detect browser support (MediaRecorder + microphone)
  var voiceSearchSupported = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder);

  // ============================================
  // SVG ICONS
  // ============================================

  var ICONS = {
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>',
    car: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18 10l-2.7-3.6A1 1 0 0 0 14.5 6h-5a1 1 0 0 0-.8.4L6 10l-2.5 1.1C2.7 11.3 2 12.1 2 13v3c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>',
    image: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21"/></svg>',
    external: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>',
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
    package: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>',
    chevronRight: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    mic: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="1" width="6" height="11" rx="3"/><path d="M19 10v1a7 7 0 0 1-14 0v-1"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>'
  };

  // ============================================
  // CACHE
  // ============================================

  function cacheGet(key) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + key);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (Date.now() - entry.ts > CACHE_TTL) {
        sessionStorage.removeItem(CACHE_PREFIX + key);
        return null;
      }
      return entry.data;
    } catch (e) {
      return null;
    }
  }

  function cacheSet(key, data) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ data: data, ts: Date.now() }));
    } catch (e) {
      // Storage full, clear old entries
      clearOldCache();
    }
  }

  function clearOldCache() {
    try {
      var keys = [];
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        if (k && k.indexOf(CACHE_PREFIX) === 0) keys.push(k);
      }
      // Remove oldest half
      keys.sort();
      for (var j = 0; j < Math.ceil(keys.length / 2); j++) {
        sessionStorage.removeItem(keys[j]);
      }
    } catch (e) {}
  }

  // ============================================
  // API
  // ============================================

  function apiFetch(endpoint) {
    var cached = cacheGet(endpoint);
    if (cached) return Promise.resolve(cached);

    return fetch(API_URL + endpoint)
      .then(function (res) {
        if (!res.ok) throw new Error('API error: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        cacheSet(endpoint, data);
        return data;
      });
  }

  // Base URL for serving uploaded images (separate from API)
  var UPLOADS_URL = API_URL.replace(/\/rtmaroc-public\/?$/, '/rtmaroc-uploads');

  function resolveImageUrl(url) {
    if (!url) return '';
    // Already absolute URL (Shopify CDN or external)
    if (url.indexOf('http') === 0) return url;
    // Relative /uploads/ path -> use uploads URL
    if (url.indexOf('/uploads/') === 0) return UPLOADS_URL + url.replace('/uploads/', '/');
    // Other relative URL -> prepend API server
    return API_URL + url;
  }

  // ============================================
  // SCROLL MANAGEMENT
  // ============================================

  var scrollPositions = {};
  var pendingScroll = null; // 'catalogue-top' | 'restore:key' | null (no scroll)

  function saveScroll(key) {
    // Save position relative to catalogue top for consistency
    var catalogueTop = container.getBoundingClientRect().top + window.scrollY;
    scrollPositions[key] = window.scrollY - catalogueTop;
  }

  function scrollToCatalogue() {
    var catalogueTop = container.getBoundingClientRect().top + window.scrollY;
    // Small offset so the header bar is visible with breathing room
    var offset = Math.max(0, catalogueTop - 10);
    window.scrollTo({ top: offset, behavior: 'smooth' });
  }

  function restoreScrollRelative(key) {
    var relative = scrollPositions[key];
    if (relative == null) { scrollToCatalogue(); return; }
    var catalogueTop = container.getBoundingClientRect().top + window.scrollY;
    var target = catalogueTop + relative;
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  }

  // ============================================
  // URL / HISTORY
  // ============================================

  function updateUrl() {
    var hash = '';
    if (state.brand) {
      hash += 'brand=' + encodeURIComponent(state.brand);
      if (state.model) {
        hash += '&model=' + encodeURIComponent(state.model);
      }
    }
    var newHash = hash ? '#' + hash : '';
    if (window.location.hash !== newHash) {
      history.pushState(null, '', window.location.pathname + newHash);
    }
    // Update page title
    var title = 'Pieces Carrosserie';
    if (state.brand) title = state.brand + ' - ' + title;
    if (state.model) title = state.model + ' ' + state.brand + ' - Pieces Carrosserie';
    document.title = title + ' | RT MAROC';
  }

  function parseUrl() {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return { brand: null, model: null };
    var params = {};
    hash.split('&').forEach(function (pair) {
      var parts = pair.split('=');
      if (parts.length === 2) params[parts[0]] = decodeURIComponent(parts[1]);
    });
    return { brand: params.brand || null, model: params.model || null };
  }

  // ============================================
  // NAVIGATION
  // ============================================

  function navigate(view, brand, model) {
    // Save current scroll position before changing view
    var currentKey = state.view + (state.brand ? '-' + state.brand : '') + (state.model ? '-' + state.model : '');
    saveScroll(currentKey);

    // Determine scroll strategy: going back = restore, going forward = top of catalogue
    var targetKey = view + (brand ? '-' + brand : '') + (model ? '-' + model : '');
    var isGoingBack = (view === 'brands' && state.view !== 'brands') ||
                      (view === 'models' && state.view === 'products');

    if (isGoingBack && scrollPositions[targetKey] != null) {
      pendingScroll = 'restore:' + targetKey;
    } else {
      pendingScroll = 'catalogue-top';
    }

    // Clear stale data when changing brand or view
    if (brand !== state.brand || view === 'brands') {
      state.models = [];
      state.products = [];
      state.productsLoaded = false;
    }
    if (model !== state.model || view !== 'products') {
      state.products = [];
      state.productsLoaded = false;
    }

    state.view = view;
    state.brand = brand || null;
    state.model = model || null;
    state.search = '';
    state.activeCategory = 'all';
    state.productsShown = PRODUCTS_PER_BATCH;

    updateUrl();
    render();
  }

  function goHome() {
    navigate('brands', null, null);
  }

  function goToBrand(brand) {
    navigate('models', brand, null);
  }

  function goToModel(brand, model) {
    navigate('products', brand, model);
  }

  function goBack() {
    if (state.view === 'products') {
      navigate('models', state.brand, null);
    } else if (state.view === 'models') {
      navigate('brands', null, null);
    }
  }

  // Listen for browser back/forward
  window.addEventListener('popstate', function () {
    var params = parseUrl();
    var newView, newBrand, newModel;
    if (params.model && params.brand) {
      newView = 'products'; newBrand = params.brand; newModel = params.model;
    } else if (params.brand) {
      newView = 'models'; newBrand = params.brand; newModel = null;
    } else {
      newView = 'brands'; newBrand = null; newModel = null;
    }

    // Try to restore saved position for the target view
    var targetKey = newView + (newBrand ? '-' + newBrand : '') + (newModel ? '-' + newModel : '');
    if (scrollPositions[targetKey] != null) {
      pendingScroll = 'restore:' + targetKey;
    } else {
      pendingScroll = 'catalogue-top';
    }

    state.view = newView;
    state.brand = newBrand;
    state.model = newModel;
    state.search = '';
    state.activeCategory = 'all';
    state.productsShown = PRODUCTS_PER_BATCH;
    state.productsLoaded = false;
    render();
  });

  // ============================================
  // STICKY NAVIGATION BAR
  // ============================================

  var stickyNav = null;

  function updateStickyNav() {
    if (!stickyNav) {
      stickyNav = document.createElement('div');
      stickyNav.className = 'cat-sticky-nav';
      stickyNav.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-sticky-action]');
        if (!btn) return;
        var act = btn.getAttribute('data-sticky-action');
        if (act === 'back') goBack();
        else if (act === 'home') goHome();
        else if (act === 'forward') {
          // Forward = go to last visited deeper level if possible
          if (state.view === 'brands' && state.brand) goToBrand(state.brand);
          else if (state.view === 'models' && state.brand && state.model) goToModel(state.brand, state.model);
        }
      });
      document.body.appendChild(stickyNav);
    }

    // Hide on brands view (nothing to go back to)
    if (state.view === 'brands') {
      stickyNav.classList.remove('cat-sticky-nav--visible');
      return;
    }

    // Build breadcrumb label
    var label = '';
    var backLabel = '';
    var showForward = false;

    if (state.view === 'models') {
      backLabel = 'Retour';
      label = escapeHtml(state.brand);
    } else if (state.view === 'products') {
      backLabel = 'Retour';
      label = escapeHtml(state.model);
    }

    var html = '';
    html += '<button class="cat-sticky-nav__btn cat-sticky-nav__btn--back" data-sticky-action="back">';
    html += '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>';
    html += '<span>' + backLabel + '</span>';
    html += '</button>';
    html += '<div class="cat-sticky-nav__current">' + label + '</div>';
    html += '<button class="cat-sticky-nav__btn cat-sticky-nav__btn--home" data-sticky-action="home">';
    html += '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>';
    html += '<span>Accueil</span>';
    html += '</button>';

    stickyNav.innerHTML = html;
    stickyNav.classList.add('cat-sticky-nav--visible');
  }

  // ============================================
  // RENDER ENGINE
  // ============================================

  var renderPending = false;
  var refocusSearchAfterRender = false;

  function render() {
    if (!root) return;

    // Debounce rapid render calls (e.g. from multiple state changes)
    if (renderPending) return;
    renderPending = true;

    requestAnimationFrame(function () {
      renderPending = false;

      root.style.display = 'block';
      if (loading) {
        loading.style.display = 'none';
      }

      var html = '';
      switch (state.view) {
        case 'brands':
          html = renderBrands();
          break;
        case 'models':
          html = renderModels();
          break;
        case 'products':
          html = renderProducts();
          break;
      }

      root.innerHTML = html;
      bindEvents();
      updateStickyNav();

      // Show/hide floating quote helper on products view
      if (state.view === 'products' && state.productsLoaded) {
        showQuoteHelper();
      } else {
        hideQuoteHelper();
      }

      // Refocus search input after DOM rebuild
      if (refocusSearchAfterRender) {
        refocusSearchAfterRender = false;
        var newInput = root.querySelector('[data-action="search"]');
        if (newInput) {
          newInput.focus();
          newInput.setSelectionRange(newInput.value.length, newInput.value.length);
        }
      }

      // Execute pending scroll action (only once per navigation)
      if (pendingScroll) {
        var scrollAction = pendingScroll;
        pendingScroll = null;
        requestAnimationFrame(function () {
          if (scrollAction === 'catalogue-top') {
            scrollToCatalogue();
          } else if (scrollAction.indexOf('restore:') === 0) {
            restoreScrollRelative(scrollAction.replace('restore:', ''));
          }
        });
      }
    });
  }

  // ============================================
  // RENDER: BRANDS
  // ============================================

  function renderBrands() {
    var brands = state.brands;
    var search = state.search.toLowerCase();

    if (search) {
      brands = brands.filter(function (b) {
        return b.name.toLowerCase().indexOf(search) !== -1;
      });
    }

    var html = '';

    // RT Smart Bar — exact design from mockup
    html += '<div class="cat-smartbar">';
    // Gray bar background
    html += '<div class="cat-smartbar__bar">';

    // LEFT: pill button "Selectionnez la marque de votre vehicule" + red dot
    html += '<div class="cat-smartbar__left">';
    html += '<span class="cat-smartbar__label">S\u00e9lectionnez la marque de votre v\u00e9hicule</span>';
    html += '<span class="cat-smartbar__dot"><span class="cat-smartbar__dot-glow"></span></span>';
    html += '</div>';

    // CENTER: floating mic circle + AI pill
    html += '<div class="cat-smartbar__center">';
    html += '<button class="cat-smartbar__mic" data-action="voice-search" type="button">';
    html += '<span class="cat-smartbar__mic-glow"></span>';
    html += '<span class="cat-smartbar__mic-ring"></span>';
    html += '<svg class="cat-smartbar__mic-icon" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#e94141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="1" width="6" height="11" rx="3"/><path d="M19 10v1a7 7 0 0 1-14 0v-1"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>';
    html += '</button>';
    html += '<div class="cat-smartbar__ai-pill" data-action="voice-search">';
    html += '<span class="cat-smartbar__ai-ar">\u0628\u062D\u062B \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0625\u0635\u0637\u0646\u0627\u0639\u064A</span>';
    html += '<span class="cat-smartbar__ai-fr">سجل أوديو باش نعرفو سيارتك</span>';
    html += '</div>';
    html += '</div>';

    // RIGHT: search pill
    html += '<div class="cat-smartbar__right">';
    html += '<div class="cat-smartbar__search-pill">';
    html += '<input type="text" class="cat-smartbar__search-input" placeholder="\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0628\u0627\u0633\u0629 - Recherche" data-action="product-search" autocomplete="nope" autocorrect="off" autocapitalize="off" spellcheck="false" name="q1773054188585" id="cat-piece-search">';
    html += '<button class="cat-smartbar__search-btn" data-action="product-search-go" type="button">' + ICONS.search + '</button>';
    html += '<div class="cat-smartbar__suggestions" id="cat-piece-suggestions"></div>';
    html += '</div>';
    html += '</div>';

    html += '</div>'; // bar
    
    // ── MOBILE SMARTBAR (hidden on desktop) ──
    html += '<div class="cat-smartbar-mobile">';
    // Two columns
    html += '<div class="csm-grid">';
    // LEFT: search
    html += '<div class="csm-col" data-action="mobile-search-open">';
    html += '<div class="csm-circle">';
    html += '<div class="csm-circle__inner">';
    html += '<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="#e94141" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    html += '</div>';
    html += '</div>';
    html += '<div class="csm-pill">';
    html += '<span class="csm-pill__main">Recherche - \u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0628\u0627\u0633\u0629</span>';
    html += '<span class="csm-pill__sub">recherche manuel</span>';
    html += '</div>';
    html += '</div>';
    // RIGHT: AI voice
    html += '<div class="csm-col" data-action="voice-search">';
    html += '<div class="csm-circle">';
    html += '<div class="csm-circle__inner">';
    html += '<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="#e94141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="1" width="6" height="11" rx="3"/><path d="M19 10v1a7 7 0 0 1-14 0v-1"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>';
    html += '</div>';
    html += '</div>';
    html += '<div class="csm-pill">';
    html += '<span class="csm-pill__main">\u0628\u062D\u062B \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0625\u0635\u0637\u0646\u0627\u0639\u064A</span>';
    html += '<span class="csm-pill__sub">recherche par AI</span>';
    html += '</div>';
    html += '</div>';
    html += '</div>'; // close grid
    html += '</div>'; // close mobile smartbar

    // ── MOBILE SEARCH OVERLAY ──
    html += '<div class="csm-search-overlay" id="csm-search-overlay">';
    html += '<div class="csm-search-logo"><img src="' + HELPER_IMAGE.replace('rt-helper-person.png', 'rt-search-logo.png') + '" alt="RT"></div>';
    html += '<div class="csm-search-overlay__bar">';
    html += '<input type="text" class="csm-search-overlay__input" id="csm-search-input" placeholder="\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0628\u0627\u0633\u0629 - Recherche" autocomplete="off" autocorrect="off" spellcheck="false">';
    html += '<button class="csm-search-overlay__close" data-action="mobile-search-close" type="button">&times;</button>';
    html += '</div>';
    html += '<div class="csm-search-overlay__results" id="csm-search-results"></div>';
    html += '</div>';
    html += '</div>'; // smartbar



    // Grid
    html += '<div class="cat-brands-grid">';
    brands.forEach(function (brand) {
      var logoUrl = themeLogos[brand.name] || state.logos[brand.name];
      html += '<div class="cat-brand-card cat-reveal" data-action="brand" data-brand="' + escapeAttr(brand.name) + '">';
      html += '<div class="cat-brand-card__logo' + (logoUrl ? '' : ' cat-brand-card__logo--placeholder') + '">';
      if (logoUrl) {
        html += '<img src="' + escapeAttr(resolveImageUrl(logoUrl)) + '" alt="' + escapeAttr(brand.name) + '" loading="lazy" decoding="async">';
      } else {
        html += brand.name.charAt(0);
      }
      html += '</div>';
      html += '<div class="cat-brand-card__name">' + escapeHtml(brand.name) + '</div>';
      html += '<div class="cat-brand-card__count">' + brand.products + ' produits</div>';
      html += '</div>';
    });
    html += '</div>';

    html += '<div class="cat-bottom-spacer"></div>';
    return html;
  }

  // ============================================
  // RENDER: MODELS
  // ============================================

  function renderModelCard(model, brandImages) {
    var imageUrl = brandImages[model.name] || model.image;
    var html = '';
    html += '<div class="cat-model-card cat-reveal" data-action="model" data-brand="' + escapeAttr(state.brand) + '" data-model="' + escapeAttr(model.name) + '">';

    // Image
    html += '<div class="cat-model-card__image' + (imageUrl ? '' : ' cat-model-card__image--empty') + '">';
    if (imageUrl) {
      html += '<img src="' + escapeAttr(resolveImageUrl(imageUrl)) + '" alt="' + escapeAttr(model.name) + '" loading="lazy" decoding="async">';
    } else {
      html += ICONS.car;
    }
    html += '</div>';

    // Info
    html += '<div class="cat-model-card__info">';
    html += '<div class="cat-model-card__name">' + escapeHtml(model.label || model.name) + '</div>'; // [SERIES-ORDER 01/11] « Classe C W204 »
    html += '<div class="cat-model-card__meta">';
    html += '<span>' + model.products + ' produits</span>';
    if (model.yearsDisplay) {
      html += '<span class="cat-model-card__years">' + escapeHtml(model.yearsDisplay) + '</span>';
    }
    html += '</div>';
    html += '</div>';

    html += '</div>';
    return html;
  }

  function renderModels() {
    var html = '';

    // Header
    html += '<div class="cat-header"><div class="cat-header__inner">';
    html += '<button class="cat-header__back" data-action="back">' + ICONS.back + '</button>';
    html += '<div class="cat-breadcrumb">';
    html += '<span class="cat-breadcrumb__item" data-action="home">Accueil</span>';
    html += '<span class="cat-breadcrumb__sep">' + ICONS.chevronRight + '</span>';
    html += '<span class="cat-breadcrumb__current">' + escapeHtml(state.brand) + '</span>';
    html += '</div>';
    html += '<div class="cat-header__search">';
    html += '<span class="cat-header__search-icon">' + ICONS.search + '</span>';
    html += '<input type="text" class="cat-header__search-input" placeholder="Rechercher un modele..." data-action="search" value="' + escapeAttr(state.search) + '">';
    html += '</div>';
    html += '</div></div>';

    // Check if models are loaded
    if (!state.models || state.models.length === 0) {
      html += renderLoading('Chargement des modeles...');
      loadModels(state.brand);
      return html;
    }

    var models = state.models;
    var search = state.search.toLowerCase();
    var brandImages = state.images[state.brand] || {};

    // Filter by search - for groups, match group name or any variant name
    if (search) {
      models = [];
      for (var i = 0; i < state.models.length; i++) {
        var m = state.models[i];
        if (m.variants && m.variants.length > 0) {
          // Series group: filter variants that match
          var matchingVariants = m.variants.filter(function (v) {
            return v.name.toLowerCase().indexOf(search) !== -1 || m.name.toLowerCase().indexOf(search) !== -1;
          });
          if (matchingVariants.length > 0) {
            models.push({ name: m.name, label: m.label, products: m.products, image: m.image, yearsDisplay: m.yearsDisplay, variants: matchingVariants });
          }
        } else {
          if (m.name.toLowerCase().indexOf(search) !== -1) {
            models.push(m);
          }
        }
      }
    }

    // Count total individual models
    var totalModels = 0;
    models.forEach(function (m) {
      totalModels += (m.variants && m.variants.length > 0) ? m.variants.length : 1;
    });

    // Title
    html += '<div class="cat-title-bar">';
    html += '<h1>Selectionnez le modele de votre voiture <span class="cat-title-bar__count">(' + totalModels + ' modeles ' + escapeHtml(state.brand) + ')</span></h1>';
    html += '</div>';

    // Render models: series groups get a divider + grid, singles are collected into shared grids
    var singleCards = '';
    var flushSingles = function () {
      if (singleCards) {
        html += '<div class="cat-models-grid">' + singleCards + '</div>';
        singleCards = '';
      }
    };

    models.forEach(function (model) {
      if (model.variants && model.variants.length > 0) {
        // Flush any pending singles before a series divider
        flushSingles();

        // Series group with divider
        html += '<div class="cat-series-group">';
        html += '<div class="cat-series-divider cat-reveal">';
        html += '<div class="cat-series-divider__line"></div>';
        html += '<div class="cat-series-divider__label">';
        html += '<span class="cat-series-divider__name">' + escapeHtml(model.name) + '</span>';
        html += '<span class="cat-series-divider__count">' + model.products + ' produits</span>';
        html += '</div>';
        html += '<div class="cat-series-divider__line"></div>';
        html += '</div>';

        // Variant cards grid
        html += '<div class="cat-models-grid">';
        model.variants.forEach(function (variant) {
          html += renderModelCard(variant, brandImages);
        });
        html += '</div>';
        html += '</div>';
      } else {
        // Collect single models into the same grid
        singleCards += renderModelCard(model, brandImages);
      }
    });

    // Flush remaining singles
    flushSingles();

    html += '<div class="cat-bottom-spacer"></div>';
    return html;
  }

  // ============================================
  // RENDER: PRODUCTS
  // ============================================

  function renderProducts() {
    var html = '';

    // Header
    html += '<div class="cat-header"><div class="cat-header__inner">';
    html += '<button class="cat-header__back" data-action="back">' + ICONS.back + '</button>';
    html += '<div class="cat-breadcrumb">';
    html += '<span class="cat-breadcrumb__item" data-action="home">Accueil</span>';
    html += '<span class="cat-breadcrumb__sep">' + ICONS.chevronRight + '</span>';
    html += '<span class="cat-breadcrumb__item" data-action="brand" data-brand="' + escapeAttr(state.brand) + '">' + escapeHtml(state.brand) + '</span>';
    html += '<span class="cat-breadcrumb__sep">' + ICONS.chevronRight + '</span>';
    html += '<span class="cat-breadcrumb__current">' + escapeHtml(state.model) + '</span>';
    html += '</div>';
    html += '<div class="cat-header__search">';
    html += '<span class="cat-header__search-icon">' + ICONS.search + '</span>';
    html += '<input type="text" class="cat-header__search-input" placeholder="Rechercher un produit..." data-action="search" value="' + escapeAttr(state.search) + '">';
    html += '</div>';
    html += '</div></div>';

    // Check if products are loaded
    if (!state.productsLoaded) {
      html += renderLoading('Chargement des produits...');
      loadProducts(state.brand, state.model);
      return html;
    }

    // Products loaded but empty
    if (!state.products || state.products.length === 0) {
      html += '<div class="cat-empty-state">';
      html += '<div class="cat-empty-state__icon-ring">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>';
      html += '</div>';
      html += '<h3 class="cat-empty-state__title">Aucune piece disponible</h3>';
      html += '<p class="cat-empty-state__text">Le catalogue ne contient pas encore de pieces de carrosserie pour <strong>' + escapeHtml(state.brand + ' ' + state.model) + '</strong>.</p>';
      html += '<p class="cat-empty-state__hint">Nous enrichissons regulierement notre catalogue. N\'hesitez pas a nous contacter pour toute demande specifique.</p>';
      html += '<div class="cat-empty-state__actions">';
      html += '<button class="cat-empty-state__back" data-action="back">' + ICONS.back + ' Choisir un autre modele</button>';
      html += '</div>';
      html += '</div>';
      return html;
    }

    // Model header with image
    var brandImages = state.images[state.brand] || {};
    var modelImage = brandImages[state.model];

    html += '<div class="cat-model-header cat-reveal">';
    if (modelImage) {
      html += '<div class="cat-model-header__image">';
      html += '<img src="' + escapeAttr(resolveImageUrl(modelImage)) + '" alt="' + escapeAttr(state.model) + '">';
      html += '</div>';
    }
    html += '<div class="cat-model-header__info">';
    html += '<h2>Selectionnez la piece que vous voulez</h2>';

    // Find model years
    var modelInfo = findModelInfo(state.brand, state.model);
    var totalProducts = 0;
    state.products.forEach(function (cat) { totalProducts += cat.products.length; });

    var metaParts = [escapeHtml(state.model) + ' ' + escapeHtml(state.brand), totalProducts + ' produits'];
    if (modelInfo && modelInfo.yearsDisplay) metaParts.push(modelInfo.yearsDisplay);
    html += '<p>' + metaParts.join(' &bull; ') + '</p>';
    html += '</div>';
    html += '</div>';

    // Category tabs
    var categories = state.products;
    var search = state.search.toLowerCase();

    // Filter products by search
    if (search) {
      categories = categories.map(function (cat) {
        return {
          id: cat.id,
          label: cat.label,
          products: cat.products.filter(function (p) {
            return p.title.toLowerCase().indexOf(search) !== -1;
          })
        };
      }).filter(function (cat) { return cat.products.length > 0; });
    }

    // Category tabs
    html += '<div class="cat-tabs" style="margin-top:16px;">';
    var allCount = 0;
    categories.forEach(function (c) { allCount += c.products.length; });

    html += '<button class="cat-tab' + (state.activeCategory === 'all' ? ' cat-tab--active' : '') + '" data-action="category" data-category="all">';
    html += 'Tous <span class="cat-tab__count">(' + allCount + ')</span></button>';

    categories.forEach(function (cat) {
      html += '<button class="cat-tab' + (state.activeCategory === cat.id ? ' cat-tab--active' : '') + '" data-action="category" data-category="' + escapeAttr(cat.id) + '">';
      html += escapeHtml(cat.label) + ' <span class="cat-tab__count">(' + cat.products.length + ')</span></button>';
    });
    html += '</div>';

    // Products by category
    var visibleCategories = state.activeCategory === 'all'
      ? categories
      : categories.filter(function (c) { return c.id === state.activeCategory; });

    visibleCategories.forEach(function (cat) {
      html += '<div class="cat-products-section">';
      html += '<div class="cat-products-section__header cat-reveal">';
      html += '<span class="cat-products-section__title">' + escapeHtml(cat.label) + '</span>';
      html += '<span class="cat-products-section__count">' + cat.products.length + ' produits</span>';
      html += '</div>';

      html += '<div class="cat-products-grid">';
      cat.products.forEach(function (product) {
        html += renderProductCard(product, cat.label);
      });
      html += '</div>';
      html += '</div>';
    });

    if (visibleCategories.length === 0) {
      html += '<div class="cat-empty">';
      html += ICONS.package;
      html += '<h3>Aucun produit trouve</h3>';
      html += '<p>Essayez une autre recherche ou categorie.</p>';
      html += '</div>';
    }

    html += '<div class="cat-bottom-spacer"></div>';

    return html;
  }

  // ============================================
  // QUOTE HELPER (Floating person + Modal)
  // ============================================

  var QUOTE_WHATSAPP = '212684646235';
  var quoteNavCache = null;
  var helperEl = null;
  var modalEl = null;
  var HELPER_IMAGE = container.getAttribute('data-helper-image') || '';

  function createQuoteHelper() {
    if (helperEl) return;

    // Floating helper: person image + speech bubble
    helperEl = document.createElement('div');
    helperEl.className = 'quote-helper';
    helperEl.innerHTML = '<div class="quote-helper__bubble">'
      + '<span dir="rtl">\u0645\u0627 \u0644\u0642\u064a\u062a\u064a\u0634 \u0627\u0644\u0642\u0637\u0639\u0629 \u061f</span>'
      + '<strong dir="rtl">\u0625\u0636\u063a\u0637 \u0647\u0646\u0627 \u0648 \u0639\u0627\u0648\u0646\u0648\u0643 !</strong>'
      + '<div class="quote-helper__bubble-arrow"></div>'
      + '</div>'
      + '<div class="quote-helper__person">'
      + '<img src="' + escapeAttr(HELPER_IMAGE) + '" alt="RT MAROC - Demandez votre piece">'
      + '</div>';
    helperEl.style.display = 'none';
    document.body.appendChild(helperEl);

    // Open quote modal when clicking the helper
    helperEl.addEventListener("click", function(e) {
      e.stopPropagation();
      openQuoteModal();
    });

    // Keep helper pinned to the right edge of catalogue container
    function positionHelper() {
      var catEl = document.getElementById('catalogue-app') || container;
      if (!catEl || !helperEl) return;
      var rect = catEl.getBoundingClientRect();
      var rightOffset = window.innerWidth - rect.right - 140;
      helperEl.style.right = Math.max(rightOffset, 12) + 'px';
    }
    positionHelper();
    window.addEventListener('resize', positionHelper);
    window.addEventListener('scroll', positionHelper);

    // Create the modal (once)
    createQuoteModal();
  }

  function createQuoteModal() {
    if (modalEl) return;

    modalEl = document.createElement('div');
    modalEl.className = 'quote-modal';
    modalEl.style.display = 'none';

    var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    var h = '<div class="quote-modal__backdrop"></div>';
    h += '<div class="quote-modal__card">';
    h += '<button class="quote-modal__close" type="button">&times;</button>';
    h += '<div class="quote-modal__header">';
    h += '<div class="quote-modal__icon">';
    h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>';
    h += '</div>';
    h += '<h3 dir="rtl" style="font-family:Cairo,sans-serif;">\u0637\u0644\u0628 \u0642\u0637\u0639\u0629 \u063a\u064a\u0627\u0631</h3>';
    h += '<p dir="rtl" style="font-family:Cairo,sans-serif;">عمّر الاستمارة \u0648 \u063a\u0627\u062f\u064a \u0646\u062a\u0648\u0627\u0635\u0644\u0648 \u0645\u0639\u0627\u0643 \u0641 WhatsApp.</p>';
    h += '</div>';

    h += '<form class="quote-modal__form" id="quote-form">';

    h += '<div class="quote-modal__row">';
    h += '<div class="quote-modal__field">';
    h += '<label>Marque <span dir="rtl" style="font-family:Cairo,sans-serif;color:var(--cat-text-muted);font-weight:400;">(\u0627\u0644\u0645\u0627\u0631\u0643\u0627)</span></label>';
    h += '<select name="brand" id="quote-brand" required><option value="">\u0627\u062e\u062a\u0627\u0631...</option></select>';
    h += '</div>';
    h += '<div class="quote-modal__field">';
    h += '<label>Mod\u00e8le <span dir="rtl" style="font-family:Cairo,sans-serif;color:var(--cat-text-muted);font-weight:400;">(\u0627\u0644\u0645\u0648\u062f\u064a\u0644)</span></label>';
    h += '<select name="model" id="quote-model" required><option value="">\u0627\u062e\u062a\u0627\u0631...</option></select>';
    h += '</div>';
    h += '</div>';

    h += '<div class="quote-modal__row">';
    h += '<div class="quote-modal__field">';
    h += '<label>Ann\u00e9e <span dir="rtl" style="font-family:Cairo,sans-serif;color:var(--cat-text-muted);font-weight:400;">(\u0627\u0644\u0639\u0627\u0645)</span></label>';
    h += '<input type="number" name="year" min="1990" max="2026" placeholder="ex: 2018">';
    h += '</div>';
    h += '<div class="quote-modal__field">';
    h += '<label>T\u00e9l\u00e9phone <span dir="rtl" style="font-family:Cairo,sans-serif;color:var(--cat-text-muted);font-weight:400;">(\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641)</span> <span style="color:var(--cat-accent)">*</span></label>';
    h += '<input type="tel" name="phone" placeholder="06 XX XX XX XX" required>';
    h += '</div>';
    h += '</div>';

    h += '<div class="quote-modal__field">';
    h += '<label>Pi\u00e8ce recherch\u00e9e <span dir="rtl" style="font-family:Cairo,sans-serif;color:var(--cat-text-muted);font-weight:400;">(\u0627\u0644\u0642\u0637\u0639\u0629 \u0644\u064a \u0643\u062a\u0642\u0644\u0651\u0628 \u0639\u0644\u064a\u0647\u0627)</span></label>';
    h += '<input type="text" name="description" placeholder="ex: Optique avant gauche, Pare-choc arri\u00e8re...">';
    h += '</div>';

    h += '<div class="quote-modal__field">';
    h += '<label>Photo <span dir="rtl" style="font-family:Cairo,sans-serif;color:var(--cat-text-muted);font-weight:400;">(\u0635\u0648\u0631\u0629 \u062f\u064a\u0627\u0644 \u0627\u0644\u0642\u0637\u0639\u0629)</span></label>';
    if (isMobile) {
      h += '<div class="quote-modal__upload-row">';
      h += '<div class="quote-modal__upload" id="quote-upload-camera">';
      h += '<input type="file" name="photo-cam" accept="image/*" capture="environment" id="quote-photo-camera" hidden>';
      h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>';
      h += '<span dir="rtl" style="font-family:Cairo,sans-serif;">صور بالكاميرا</span>';
      h += '</div>';
      h += '<div class="quote-modal__upload" id="quote-upload-gallery">';
      h += '<input type="file" name="photo-gal" accept="image/*" id="quote-photo-gallery" hidden>';
      h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
      h += '<span dir="rtl" style="font-family:Cairo,sans-serif;">من التيليفون</span>';
      h += '</div>';
      h += '</div>';
    } else {
      h += '<div class="quote-modal__upload" id="quote-upload-zone">';
      h += '<input type="file" name="photo" accept="image/*" id="quote-photo" hidden>';
      h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>';
      h += '<span>Choisir un fichier <span dir="rtl" style="font-family:Cairo,sans-serif;">(\u0645\u0646 \u0627\u0644\u062c\u0647\u0627\u0632)</span></span>';
      h += '</div>';
    }
    h += '<div class="quote-modal__preview" id="quote-preview"></div>';
    h += '</div>';

    h += '<button type="submit" class="quote-modal__submit">';
    h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;vertical-align:middle;margin-left:6px"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>';
    h += '<span dir="rtl" style="font-family:Cairo,sans-serif;">\u0635\u064a\u0641\u0637 \u0627\u0644\u0637\u0644\u0628</span>';
    h += '</button>';

    h += '</form>';

    h += '<div class="quote-modal__success" id="quote-success" style="display:none;">';
    h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
    h += '<p dir="rtl" style="font-family:Cairo,sans-serif;">\u0627\u0644\u0637\u0644\u0628 \u062a\u0635\u064a\u0641\u0637 \u0628\u0646\u062c\u0627\u062d !</p>';
    h += '<small dir="rtl" style="font-family:Cairo,sans-serif;">\u063a\u0627\u062f\u064a \u0646\u062a\u0648\u0627\u0635\u0644\u0648 \u0645\u0639\u0627\u0643 \u0641 WhatsApp.</small>';
    h += '</div>';

    h += '</div>';

    modalEl.innerHTML = h;
    document.body.appendChild(modalEl);

    // Close modal events
    modalEl.querySelector('.quote-modal__backdrop').addEventListener('click', closeQuoteModal);
    modalEl.querySelector('.quote-modal__close').addEventListener('click', closeQuoteModal);

    // Upload zone - handles both mobile (camera+gallery) and desktop (file picker)
    var activePhotoFile = null;
    function setupUploadBtn(zoneId, inputId) {
      var zone = modalEl.querySelector('#' + zoneId);
      var input = modalEl.querySelector('#' + inputId);
      if (zone && input) {
        zone.addEventListener('click', function () { input.click(); });
        input.addEventListener('change', function () {
          activePhotoFile = (this.files && this.files[0]) ? this.files[0] : null;
          var preview = modalEl.querySelector('#quote-preview');
          if (activePhotoFile && preview) {
            var reader = new FileReader();
            reader.onload = function (e) {
              preview.innerHTML = '<img src="' + e.target.result + '" alt="Preview" style="max-width:100%;max-height:150px;border-radius:8px;margin-top:8px;">';
            };
            reader.readAsDataURL(activePhotoFile);
          } else if (preview) {
            preview.innerHTML = '';
          }
        });
      }
    }
    setupUploadBtn('quote-upload-zone', 'quote-photo');
    setupUploadBtn('quote-upload-camera', 'quote-photo-camera');
    setupUploadBtn('quote-upload-gallery', 'quote-photo-gallery');

    // Form submit - save to backend, WhatsApp sent automatically by bot
    var quoteForm = modalEl.querySelector('#quote-form');
    if (quoteForm) {
      quoteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = quoteForm.querySelector('.quote-modal__submit');
        var resetBtnHtml = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;vertical-align:middle;margin-left:6px"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg><span dir="rtl" style="font-family:Cairo,sans-serif;">\u0635\u064a\u0641\u0637 \u0627\u0644\u0637\u0644\u0628</span>';
        if (btn) { btn.disabled = true; btn.innerHTML = '<span dir="rtl" style="font-family:Cairo,sans-serif;">\u0643\u0627\u0646\u0635\u064a\u0641\u0637...</span>'; }

        var formData = new FormData();
        formData.append('brand', quoteForm.querySelector('[name="brand"]').value);
        formData.append('model', quoteForm.querySelector('[name="model"]').value);
        formData.append('year', quoteForm.querySelector('[name="year"]') ? quoteForm.querySelector('[name="year"]').value : '');
        formData.append('phone', quoteForm.querySelector('[name="phone"]').value);
        formData.append('description', quoteForm.querySelector('[name="description"]') ? quoteForm.querySelector('[name="description"]').value : '');
        if (activePhotoFile) formData.append('photo', activePhotoFile);

        fetch(API_URL + '/quote-request', { method: 'POST', body: formData })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.success) {
              quoteForm.style.display = 'none';
              var success = modalEl.querySelector('#quote-success');
              if (success) success.style.display = '';
            } else {
              if (btn) { btn.disabled = false; btn.innerHTML = resetBtnHtml; }
              alert('Erreur: ' + (data.message || 'Veuillez reessayer.'));
            }
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = resetBtnHtml; }
            alert('Erreur de connexion. Veuillez reessayer.');
          });
      });
    }

  }
  function loadQuoteNavigation(callback) {
    if (quoteNavCache) { callback(quoteNavCache); return; }
    if (state.brands && state.brands.length > 0 && state.navigation) {
      quoteNavCache = { brands: state.brands, models: state.navigation, images: state.images || {} };
      callback(quoteNavCache);
      return;
    }
    apiFetch('/navigation').then(function (data) {
      if (data.success) {
        quoteNavCache = { brands: data.brands || [], models: data.models || {}, images: data.images || {} };
      }
      callback(quoteNavCache);
    }).catch(function () { callback(null); });
  }

  function openQuoteModal() {
    if (!modalEl) return;

    // Reset form state
    var form = modalEl.querySelector('#quote-form');
    var success = modalEl.querySelector('#quote-success');
    if (form) { form.style.display = ''; form.reset(); }
    if (success) success.style.display = 'none';
    var preview = modalEl.querySelector('#quote-preview');
    if (preview) preview.innerHTML = '';
    var btn = modalEl.querySelector('.quote-modal__submit');
    if (btn) { btn.disabled = false; btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;vertical-align:middle;margin-right:6px"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>Envoyer ma demande'; }

    // Pre-fill brand/model from current catalogue state
    var currentBrand = state.brand || '';
    var currentModel = state.model || '';

    loadQuoteNavigation(function (navData) {
      if (!navData) return;
      var bs = modalEl.querySelector('#quote-brand');
      if (!bs) return;
      var opts = '<option value="">-- Choisir la marque --</option>';
      for (var i = 0; i < navData.brands.length; i++) {
        var name = navData.brands[i].name || navData.brands[i];
        var sel = (name === currentBrand) ? ' selected' : '';
        opts += '<option value="' + escapeAttr(name) + '"' + sel + '>' + escapeHtml(name) + '</option>';
      }
      bs.innerHTML = opts;

      if (currentBrand && navData.models[currentBrand]) {
        var ms = modalEl.querySelector('#quote-model');
        if (ms) {
          var mOpts = '<option value="">-- Choisir le modele --</option>';
          var models = navData.models[currentBrand];
          for (var j = 0; j < models.length; j++) {
            var mName = models[j].name || models[j];
            var mSel = (mName === currentModel) ? ' selected' : '';
            mOpts += '<option value="' + escapeAttr(mName) + '"' + mSel + '>' + escapeHtml(mName) + '</option>';
          }
          ms.innerHTML = mOpts;
        }
      }

      // Brand change handler
      bs.onchange = function () {
        var ms = modalEl.querySelector('#quote-model');
        if (!ms || !quoteNavCache) return;
        var models = quoteNavCache.models[this.value] || [];
        var o = '<option value="">-- Choisir le modele --</option>';
        for (var k = 0; k < models.length; k++) {
          var mn = models[k].name || models[k];
          o += '<option value="' + escapeAttr(mn) + '">' + escapeHtml(mn) + '</option>';
        }
        ms.innerHTML = o;
      };
    });

    // Show modal
    modalEl.style.display = '';
    document.body.style.overflow = 'hidden';

    // Animate in
    requestAnimationFrame(function () {
      modalEl.classList.add('quote-modal--open');
    });
  }

  function closeQuoteModal() {
    if (!modalEl) return;
    modalEl.classList.remove('quote-modal--open');
    document.body.style.overflow = '';
    setTimeout(function () {
      modalEl.style.display = 'none';
    }, 300);
  }

  // [RT-WA-FAB 2026-10-24] Demande de devis ANNULEE (demande user) : le helper « Demandez votre piece »
  // et son formulaire (POST /quote-request) ne sont plus affiches. A la place : bouton WhatsApp collant
  // vers 0684646235, message pre-rempli avec la marque/modele consultes.
  // createQuoteHelper()/createQuoteModal() sont conserves dans le fichier mais plus jamais appeles.
  var RT_WA_NUMBER = '212684646235';
  var waFabEl = null;

  function waFabHref() {
    var msg = '\u0627\u0644\u0633\u0644\u0627\u0645 \u0639\u0644\u064a\u0643\u0645\u060c \u0628\u063a\u064a\u062a \u0646\u0639\u0631\u0641 \u0627\u0644\u062b\u0645\u0646 \u062f\u064a\u0627\u0644 \u0642\u0637\u0639\u0629';
    var car = [state.brand, state.model].filter(Boolean).join(' ');
    if (car) msg += ' \u0644 ' + car;
    return 'https://wa.me/' + RT_WA_NUMBER + '?text=' + encodeURIComponent(msg);
  }

  function createWaFab() {
    if (waFabEl) return;
    waFabEl = document.createElement('a');
    waFabEl.className = 'rt-wa-fab';
    waFabEl.target = '_blank';
    waFabEl.rel = 'noopener';
    waFabEl.setAttribute('aria-label', 'WhatsApp RT MAROC 0684646235');
    waFabEl.innerHTML = '<span class="rt-wa-fab__icon"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.126.553 4.12 1.523 5.855L0 24l6.335-1.66A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.82c-1.98 0-3.82-.567-5.38-1.545l-.386-.232-3.998 1.049 1.068-3.9-.253-.403A9.77 9.77 0 012.18 12 9.82 9.82 0 0112 2.18 9.82 9.82 0 0121.82 12 9.82 9.82 0 0112 21.82z"/></svg></span>'
      + '<span class="rt-wa-fab__label" dir="rtl"><small>\u0645\u0627 \u0644\u0642\u064a\u062a\u064a\u0634 \u0627\u0644\u0628\u064a\u0627\u0633\u0629 \u062f\u064a\u0627\u0644\u0643\u061f</small><strong>\u062a\u0648\u0627\u0635\u0644 \u0645\u0639\u0627\u0646\u0627 \u0641\u0627\u0644\u0648\u0627\u062a\u0633\u0627\u0628</strong></span>';
    // Le href est recalcule au moment du clic (marque/modele a jour)
    waFabEl.addEventListener('click', function () { waFabEl.href = waFabHref(); });
    document.body.appendChild(waFabEl);
  }

  function showQuoteHelper() {
    createWaFab();
    waFabEl.href = waFabHref();
    requestAnimationFrame(function () { waFabEl.classList.add('rt-wa-fab--in'); });
  }

  function hideQuoteHelper() {
    if (waFabEl) waFabEl.classList.remove('rt-wa-fab--in');
  }

  function renderProductCard(product, categoryLabel) {
    var html = '';
    var productUrl = '/products/' + product.handle;
    html += '<a href="' + productUrl + '" class="cat-product-card cat-reveal" data-product-link data-category="' + escapeAttr(categoryLabel || '') + '">';

    // Image
    var imgUrl = product.image_url;
    html += '<div class="cat-product-card__image' + (imgUrl ? '' : ' cat-product-card__image--empty') + '">';
    if (imgUrl) {
      html += '<img src="' + escapeAttr(resolveImageUrl(imgUrl)) + '" alt="' + escapeAttr(product.title) + '" loading="lazy" decoding="async">';
    } else {
      html += ICONS.image;
    }

    // Manufacturer badge
    var manufacturer = extractManufacturer(product.title);
    if (manufacturer) {
      html += '<span class="cat-product-card__badge">' + escapeHtml(manufacturer) + '</span>';
    }

    // External link icon
    html += '<span class="cat-product-card__link">' + ICONS.external + '</span>';

    // Action icons (cart + order)
    html += '<span class="cat-product-card__actions">';
    html += '<span class="cat-card-btn cat-card-btn--cart" data-action="add-to-cart" data-product-handle="' + escapeAttr(product.handle) + '" title="Ajouter au panier">';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>';
    html += '</span>';
    html += '<span class="cat-card-btn cat-card-btn--order" title="Commander">';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
    html += '</span>';
    html += '</span>';

    html += '</div>';

    // Info
    html += '<div class="cat-product-card__info">';
    html += '<div class="cat-product-card__title">' + escapeHtml(product.title) + '</div>';
    if (product.price) {
      html += '<div class="cat-product-card__price">' + formatPrice(product.price) + '<span class="cat-product-card__price--currency"> MAD</span></div>';
    }
    html += '</div>';

    html += '</a>';
    return html;
  }

  // ============================================
  // LOADING STATE
  // ============================================

  function renderLoading(message) {
    return '<div style="text-align:center;padding:60px 24px;color:var(--cat-text-secondary);">' +
      '<div style="width:32px;height:32px;border:3px solid var(--cat-border);border-top-color:var(--cat-accent);border-radius:50%;animation:cat-spin 0.8s linear infinite;margin:0 auto 16px;"></div>' +
      '<p>' + escapeHtml(message || 'Chargement...') + '</p>' +
      '<style>@keyframes cat-spin{to{transform:rotate(360deg)}}</style>' +
      '</div>';
  }

  function renderError(message) {
    return '<div class="cat-error">' +
      '<p>' + escapeHtml(message) + '</p>' +
      '<button class="cat-error__retry" data-action="retry">Reessayer</button>' +
      '</div>';
  }

  // ============================================
  // EVENT BINDING
  // ============================================

  function bindEvents() {
    if (!root) return;

    // Only add the delegated click listener ONCE to prevent accumulation
    if (!eventsInitialized) {
      eventsInitialized = true;
      root.addEventListener('click', handleClick);

      // Save catalogue context when clicking a product link
      root.addEventListener('click', function (e) {
        var link = e.target.closest('[data-product-link]');
        if (!link) return;
        try {
          sessionStorage.setItem('rtm_catalogue_context', JSON.stringify({
            brand: state.brand || '',
            model: state.model || '',
            category: link.getAttribute('data-category') || '',
            timestamp: Date.now()
          }));
        } catch (err) {}
      });
    }

    // Search input (new elements after each render, so re-bind is needed)
    var searchInputs = root.querySelectorAll('[data-action="search"]');
    searchInputs.forEach(function (input) {
      input.addEventListener('input', debounce(function (e) {
        state.search = e.target.value;
        state.productsShown = PRODUCTS_PER_BATCH;
        refocusSearchAfterRender = true;
        render();
      }, 200));
    });

    // Scroll reveal: observe all .cat-reveal elements
    initScrollReveal();
  }

  // ============================================
  // SCROLL REVEAL (IntersectionObserver)
  // ============================================

  var revealObserver = null;

  function initScrollReveal() {
    // Disconnect previous observer to avoid duplication
    if (revealObserver) {
      revealObserver.disconnect();
    }

    var items = root.querySelectorAll('.cat-reveal');
    if (!items.length) return;

    // Fallback: if no IntersectionObserver, show all immediately
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('cat-reveal--visible'); });
      return;
    }

    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          // Stagger delay based on position within its row
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          if (delay > 0) {
            setTimeout(function () { el.classList.add('cat-reveal--visible'); }, delay);
          } else {
            el.classList.add('cat-reveal--visible');
          }
          revealObserver.unobserve(el); // Only animate once
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -40px 0px', // Trigger slightly before fully in view
      threshold: 0.08
    });

    // Assign stagger delays per row & observe
    var grids = root.querySelectorAll('.cat-brands-grid, .cat-models-grid, .cat-products-grid');
    grids.forEach(function (grid) {
      var cards = grid.querySelectorAll('.cat-reveal');
      // Detect columns from grid layout
      var cols = 1;
      if (cards.length >= 2) {
        var firstTop = cards[0].getBoundingClientRect().top;
        for (var i = 1; i < cards.length; i++) {
          if (Math.abs(cards[i].getBoundingClientRect().top - firstTop) > 5) {
            cols = i;
            break;
          }
        }
        if (cols === 1 && cards.length > 1) cols = cards.length; // Single row
      }
      cards.forEach(function (card, idx) {
        var colIndex = idx % cols;
        card.setAttribute('data-reveal-delay', String(colIndex * 60));
        revealObserver.observe(card);
      });
    });

    // Observe non-grid reveal elements (headers, dividers, model-header)
    items.forEach(function (el) {
      if (!el.closest('.cat-brands-grid, .cat-models-grid, .cat-products-grid')) {
        revealObserver.observe(el);
      }
    });
  }

  function handleClick(e) {
    // Block <a> navigation when clicking action icons inside cards
    if (e.target.closest('.cat-product-card__actions')) {
      e.preventDefault();
      e.stopPropagation();
    }
    var target = e.target.closest('[data-action]');
    if (!target) return;

    var action = target.getAttribute('data-action');

    switch (action) {
      case 'brand':
        e.preventDefault();
        var brand = target.getAttribute('data-brand');
        if (brand) goToBrand(brand);
        break;

      case 'model':
        e.preventDefault();
        var brandName = target.getAttribute('data-brand');
        var modelName = target.getAttribute('data-model');
        if (brandName && modelName) goToModel(brandName, modelName);
        break;

      case 'back':
        e.preventDefault();
        goBack();
        break;

      case 'home':
        e.preventDefault();
        goHome();
        break;

      case 'category':
        e.preventDefault();
        var cat = target.getAttribute('data-category');
        if (cat) {
          state.activeCategory = cat;
          state.productsShown = PRODUCTS_PER_BATCH; // Reset on category change
          render();
        }
        break;

      case 'loadmore':
        e.preventDefault();
        state.productsShown += PRODUCTS_PER_BATCH;
        render();
        break;

      case 'retry':
        e.preventDefault();
        init();
        break;

      case 'add-to-cart':
          e.preventDefault();
          e.stopPropagation();
          var cartBtn = target;
          var origHTML = cartBtn.innerHTML;
          var pHandle = cartBtn.getAttribute('data-product-handle');
          if (pHandle) {
            cartBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M12 5v14M5 12h14"/></svg>';
            fetch('/products/' + pHandle + '.js').then(function(r){return r.json()}).then(function(p){
              if(p.variants&&p.variants[0]){
                return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:p.variants[0].id,quantity:1}]})});
              }
            }).then(function(){
              cartBtn.classList.add('cat-card-btn--success');
              cartBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
              setTimeout(function(){cartBtn.classList.remove('cat-card-btn--success');cartBtn.innerHTML=origHTML;},2000);
            }).catch(function(){cartBtn.innerHTML=origHTML;});
          }
          break;
        case 'mobile-search-open':
        e.preventDefault();
        var ov = document.getElementById('csm-search-overlay');
        if (ov) { ov.classList.add('active'); setTimeout(function() { document.getElementById('csm-search-input').focus(); }, 100); }
        break;
      case 'mobile-search-close':
        e.preventDefault();
        var ov2 = document.getElementById('csm-search-overlay');
        if (ov2) { ov2.classList.remove('active'); }
        break;
      case 'voice-search':
        e.preventDefault();
        openVoiceModal();
        break;
    }
  }

  // ============================================
  // DATA LOADING
  // ============================================

  function loadNavigation() {
    return apiFetch('/navigation').then(function (data) {
      if (data.success) {
        state.brands = data.brands || [];
        // Priority sort: user-defined brand order
        var _bp = ['DACIA','RENAULT','PEUGEOT','CITROEN','FIAT','FORD','VOLKSWAGEN','SKODA','SEAT','MERCEDES','BMW','OPEL','TOYOTA','NISSAN','HYUNDAI','KIA'];
        state.brands.sort(function(a, b) {
          var ai = _bp.indexOf(a.name.toUpperCase());
          var bi = _bp.indexOf(b.name.toUpperCase());
          if (ai  !== -1 && bi  !== -1) return ai - bi;
          if (ai  !== -1) return -1;
          if (bi  !== -1) return 1;
          return a.name.localeCompare(b.name);
        });
        state.images = data.images || {};

        // Build models lookup from navigation
        if (data.models) {
          state.navigation = data.models;
        }
      }
      return data;
    });
  }

  function loadLogos() {
    return apiFetch('/brand-logos').then(function (data) {
      if (data.success) {
        state.logos = data.logos || {};
      }
      return data;
    });
  }

  // Group flat models into series (e.g. LOGAN 1, LOGAN 2, LOGAN 3 → group "LOGAN" with 3 variants)
  function groupModelsBySeries(models) {
    var seriesMap = {};
    var order = [];

    for (var i = 0; i < models.length; i++) {
      var m = models[i];
      var name = m.name;
      var baseName = null;
      // [seriesName] PRIORITY: use server seriesName (works for all brands incl. Mercedes chassis W201->CLASSE C)
      // [SERIES-ALL 04/11] toujours la série du serveur, même quand elle = le nom (« 206 » rejoint « 206+ », « 207 » a son propre titre au lieu de paraître dans le groupe 206)
      if (m.seriesName) {
        baseName = m.seriesName;
      } else {
        // Fallback: parse name (legacy) — needs space, e.g. "LOGAN 1", "A3 8P", "M3 F80"
        var match = name.match(/^(.+?)\s+([A-Z0-9]{1,4})$/i);
        if (match) baseName = match[1];
      }
      if (baseName) {
        if (!seriesMap[baseName]) {
          seriesMap[baseName] = { name: baseName, products: 0, variants: [] };
          order.push(baseName);
        }
        seriesMap[baseName].variants.push(m);
        seriesMap[baseName].products += (m.products || 0);
      } else {
        // Standalone model
        order.push('__single__' + i);
        seriesMap['__single__' + i] = m;
      }
    }

    var result = [];
    for (var j = 0; j < order.length; j++) {
      var key = order[j];
      var entry = seriesMap[key];
      if (entry.variants) {
        // Always group when series detected (incl. single-chassis families like CLASSE V → W447)
        result.push(entry);
      } else {
        result.push(entry);
      }
    }
    return result;
  }

  function loadModels(brand) {
    return apiFetch('/brands/' + encodeURIComponent(brand) + '/models').then(function (data) {
      if (data.success) {
        state.models = groupModelsBySeries(data.models || []);
        render();
      }
      return data;
    }).catch(function (err) {
      root.innerHTML = renderError('Erreur de chargement des modeles: ' + err.message);
      bindEvents();
    });
  }

  function loadProducts(brand, model) {
    return apiFetch('/brands/' + encodeURIComponent(brand) + '/' + encodeURIComponent(model) + '/products').then(function (data) {
      if (data.success) {
        state.products = data.categories || [];
      }
      state.productsLoaded = true;
      render();
      return data;
    }).catch(function (err) {
      state.productsLoaded = true;
      root.innerHTML = renderError('Erreur de chargement des produits: ' + err.message);
      bindEvents();
    });
  }

  function checkManifest() {
    // Always fetch fresh (bypass cache for manifest)
    return fetch(API_URL + '/catalogue-manifest')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.version) return;
        var storedVersion = sessionStorage.getItem(MANIFEST_KEY);
        if (storedVersion && storedVersion !== data.version) {
          // Data changed - clear ALL cached data
          var keys = [];
          for (var i = 0; i < sessionStorage.length; i++) {
            var k = sessionStorage.key(i);
            if (k && k.indexOf(CACHE_PREFIX) === 0) keys.push(k);
          }
          keys.forEach(function (k) { sessionStorage.removeItem(k); });
        }
        sessionStorage.setItem(MANIFEST_KEY, data.version);
        state.manifestVersion = data.version;
      }).catch(function () {});
  }

  // ============================================
  // VOICE SEARCH (Web Speech API)
  // ============================================

  var voiceModalEl = null;
  var voiceMediaRecorder = null;
  var voiceAudioChunks = [];
  var voiceIsListening = false;
  var voiceAutoStopTimer = null;

  function createVoiceModal() {
    if (voiceModalEl) return;

    voiceModalEl = document.createElement('div');
    voiceModalEl.className = 'voice-modal';
    voiceModalEl.style.display = 'none';

    var h = '<div class="voice-modal__backdrop"></div>';
    h += '<div class="voice-modal__card">';
    h += '<button class="voice-modal__close" type="button">&times;</button>';

    // State: idle — illustration + speech bubble
    h += '<div class="voice-modal__state voice-modal__state--idle" id="voice-state-idle">';
    // Illustration: man with speech bubble
    h += '<div class="vm-illustration">';
    h += '<div class="vm-bubble">';
    h += '<div class="vm-bubble__label">\u0645\u062B\u0627\u0644 :</div>';
    h += '<ul class="vm-bubble__list">';
    h += '<li>dacia</li>';
    h += '<li>logan</li>';
    h += '<li>2008</li>';
    h += '</ul>';
    h += '<div class="vm-bubble__tail"></div>';
    h += '</div>';
    h += '<img class="vm-illustration__person" src="' + HELPER_IMAGE + '" alt="">';
    h += '</div>';
    // Title
    h += '<h3 class="vm-title" dir="rtl" style="font-family:Cairo,sans-serif;">\u0628\u062d\u062b \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0625\u0635\u0637\u0646\u0627\u0639\u064a</h3>';
    h += '<p class="vm-subtitle" dir="rtl" style="font-family:Cairo,sans-serif;">\u0633\u062c\u0644 \u0623\u0648\u062f\u064a\u0648 \u0628\u0627\u0634 \u0646\u0639\u0631\u0641\u0648 \u0633\u064a\u0627\u0631\u062a\u0643</p>';
    // Start button
    h += '<button class="voice-modal__start vm-start-btn" type="button" data-action="voice-start">';
    h += '<span class="vm-start-btn__mic">' + ICONS.mic + '</span>';
    h += '<span>\u0628\u062f\u0627 \u0627\u0644\u062a\u0633\u062c\u064a\u0644</span>';
    h += '</button>';
    h += '</div>';

    // State: listening
    h += '<div class="voice-modal__state voice-modal__state--listening" id="voice-state-listening" style="display:none;">';
    h += '<div class="voice-modal__rec-indicator">';
    h += '<span class="voice-modal__rec-dot"></span>';
    h += '<span class="voice-modal__rec-label">REC</span>';
    h += '<span class="voice-modal__rec-timer" id="voice-timer">0:00</span>';
    h += '</div>';
    h += '<div class="voice-modal__waves">';
    h += '<span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>';
    h += '</div>';
    h += '<h3 dir="rtl" style="font-family:Cairo,sans-serif;">\u0643\u0646\u0633\u0645\u0639\u0648\u0643...</h3>';
    h += '<p class="voice-modal__transcript" id="voice-transcript" dir="rtl" style="font-family:Cairo,sans-serif;">\u0647\u062f\u0631 \u062f\u0627\u0628\u0627...</p>';
    h += '<button class="voice-modal__stop" type="button" data-action="voice-stop">';
    h += '<span class="voice-modal__stop-ring"></span>';
    h += '<span class="voice-modal__stop-square"></span>';
    h += '</button>';
    h += '<p dir="rtl" style="font-family:Cairo,sans-serif;font-size:18px;color:#ffffff;margin-top:18px;font-weight:700;text-align:center;letter-spacing:0.5px;text-shadow:0 0 12px rgba(255,255,255,0.2);">\u0643\u0644\u064a\u0643\u064a \u0628\u0627\u0634 \u062a\u0648\u0642\u0641 \u0627\u0644\u062a\u0633\u062c\u064a\u0644</p>';
    h += '</div>';

    // State: processing (Groq Whisper AI)
    h += '<div class="voice-modal__state voice-modal__state--processing" id="voice-state-processing" style="display:none;">';
    h += '<div class="voice-modal__processing-spinner"></div>';
    h += '<h3>\u0643\u0646\u0627\u0644\u064a\u0632\u064a...</h3>';
    h += '<p>\u0627\u0644 AI \u0643\u062a\u062d\u0644\u0644 \u0637\u0644\u0628\u0643</p>';
    h += '</div>';

    // State: result
    h += '<div class="voice-modal__state voice-modal__state--result" id="voice-state-result" style="display:none;">';
    h += '<div class="voice-modal__result-icon">';
    h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
    h += '</div>';
    h += '<p class="voice-modal__result-text" id="voice-result-text"></p>';
    h += '<p class="voice-modal__result-nav">Navigation en cours...</p>';
    h += '</div>';

    // State: error
    h += '<div class="voice-modal__state voice-modal__state--error" id="voice-state-error" style="display:none;">';
    h += '<div class="voice-modal__error-icon">';
    h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>';
    h += '</div>';
    h += '<h3>\u0645\u0627 \u0644\u0642\u064a\u0646\u0627\u0634</h3>';
    h += '<p class="voice-modal__error-text" id="voice-error-text">\u0645\u0627 \u0642\u062f\u0631\u0646\u0627\u0634 \u0646\u0639\u0631\u0641\u0648 \u0644\u0645\u0627\u0631\u0643\u0627 \u0648\u0644\u0627 \u0644\u0645\u0648\u062f\u064a\u0644. \u0639\u0627\u0648\u062f \u062c\u0631\u0628.</p>';
    h += '<div class="voice-modal__error-actions">';
    h += '<button class="voice-modal__retry" type="button" data-action="voice-retry">\u0639\u0627\u0648\u062f</button>';
    h += '<button class="voice-modal__manual" type="button" data-action="voice-close">\u0642\u0644\u0628 \u0628\u064a\u062f\u064a\u0643</button>';
    h += '</div>';
    h += '</div>';

    // State: choice (multiple models found)
    h += '<div class="voice-modal__state voice-modal__state--choice" id="voice-state-choice" style="display:none;">';
    h += '<h3 dir="rtl" style="font-family:Cairo,sans-serif;">\u0648\u0627\u0634 \u0647\u0627\u062f \u0627\u0644\u0645\u0648\u062f\u064a\u0644 \u0647\u0648 \u0644\u064a \u0643\u062a\u0642\u0644\u0628 \u0639\u0644\u064a\u0647 \u061f</h3>';
    h += '<div class="voice-modal__choices" id="voice-choices"></div>';
    h += '</div>';

    h += '</div>'; // card

    voiceModalEl.innerHTML = h;
    document.body.appendChild(voiceModalEl);

    // Event listeners
    voiceModalEl.querySelector('.voice-modal__backdrop').addEventListener('click', closeVoiceModal);
    voiceModalEl.querySelector('.voice-modal__close').addEventListener('click', closeVoiceModal);

    voiceModalEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      switch (action) {
        case 'voice-start':
          startVoiceRecognition();
          break;
        case 'voice-stop':
          stopVoiceRecognition();
          break;
        case 'voice-retry':
          showVoiceState('idle');
          break;
        case 'voice-close':
          closeVoiceModal();
          break;
        case 'voice-pick':
          var pickBrand = btn.getAttribute('data-brand');
          var pickModel = btn.getAttribute('data-model');
          if (pickBrand && pickModel) {
            closeVoiceModal();
            goToModel(pickBrand, pickModel);
          }
          break;
      }
    });
  }

  function showVoiceState(stateName) {
    if (!voiceModalEl) return;
    var states = voiceModalEl.querySelectorAll('.voice-modal__state');
    for (var i = 0; i < states.length; i++) {
      states[i].style.display = 'none';
    }
    var target = voiceModalEl.querySelector('#voice-state-' + stateName);
    if (target) target.style.display = '';
  }

  function openVoiceModal() {
    if (!voiceModalEl) createVoiceModal();
    showVoiceState('idle');
    var transcript = voiceModalEl.querySelector('#voice-transcript');
    if (transcript) transcript.textContent = '';
    voiceModalEl.style.display = '';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      voiceModalEl.classList.add('voice-modal--open');
    });
  }

  function closeVoiceModal() {
    if (!voiceModalEl) return;
    stopVoiceRecognition();
    voiceModalEl.classList.remove('voice-modal--open');
    document.body.style.overflow = '';
    setTimeout(function () {
      voiceModalEl.style.display = 'none';
    }, 300);
  }

  function showVoiceChoices(brand, candidates, imagesSource) {
    var choicesEl = voiceModalEl.querySelector('#voice-choices');
    if (!choicesEl) return;

    var brandImages = (imagesSource && imagesSource[brand]) || {};
    var h = '';

    for (var ci = 0; ci < candidates.length; ci++) {
      var c = candidates[ci];
      var img = brandImages[c.model] || '';
      h += '<div class="voice-choice-card" data-action="voice-pick" data-brand="' + escapeAttr(c.brand) + '" data-model="' + escapeAttr(c.model) + '">';
      if (img) {
        h += '<div class="voice-choice-card__img"><img src="' + escapeAttr(img) + '" alt="' + escapeAttr(c.model) + '"></div>';
      } else {
        h += '<div class="voice-choice-card__img voice-choice-card__img--empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg></div>';
      }
      h += '<div class="voice-choice-card__info">';
      h += '<div class="voice-choice-card__name">' + escapeHtml(c.model) + '</div>';
      h += '<div class="voice-choice-card__years">' + escapeHtml(c.yearsDisplay) + '</div>';
      h += '</div>';
      h += '</div>';
    }

    choicesEl.innerHTML = h;
    showVoiceState('choice');
  }

  function startVoiceRecognition() {
    // Use MediaRecorder to capture audio, then send to Groq Whisper via backend
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      var errorText = voiceModalEl.querySelector('#voice-error-text');
      if (errorText) errorText.textContent = 'Votre navigateur ne supporte pas l\'enregistrement audio.';
      showVoiceState('error');
      return;
    }

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(function (stream) {
        voiceAudioChunks = [];
        voiceMediaRecorder = new MediaRecorder(stream);

        voiceMediaRecorder.ondataavailable = function (event) {
          if (event.data.size > 0) {
            voiceAudioChunks.push(event.data);
          }
        };

        voiceMediaRecorder.onstop = function () {
          // Stop all mic tracks
          stream.getTracks().forEach(function (track) { track.stop(); });
          clearTimeout(voiceAutoStopTimer);

          if (window._voiceTimerInterval) { clearInterval(window._voiceTimerInterval); window._voiceTimerInterval = null; }
          if (voiceAudioChunks.length === 0) {
            var errorText = voiceModalEl.querySelector('#voice-error-text');
            if (errorText) errorText.textContent = 'Nous n\'avons rien entendu. Veuillez reessayer.';
            showVoiceState('error');
            return;
          }

          // Build audio blob and send to Groq Whisper via backend
          var audioBlob = new Blob(voiceAudioChunks, { type: voiceMediaRecorder.mimeType || 'audio/webm' });
          showVoiceState('processing');
          sendVoiceToAPI(audioBlob);
        };

        voiceIsListening = true;
        showVoiceState('listening');
        voiceMediaRecorder.start();

        // Start recording timer
        var voiceTimerStart = Date.now();
        var voiceTimerEl = voiceModalEl ? voiceModalEl.querySelector('#voice-timer') : null;
        if (window._voiceTimerInterval) clearInterval(window._voiceTimerInterval);
        window._voiceTimerInterval = setInterval(function () {
          var elapsed = Math.floor((Date.now() - voiceTimerStart) / 1000);
          var mins = Math.floor(elapsed / 60);
          var secs = elapsed % 60;
          if (voiceTimerEl) voiceTimerEl.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
        }, 200);

        // Auto-stop after 10 seconds
        voiceAutoStopTimer = setTimeout(function () {
          if (voiceMediaRecorder && voiceMediaRecorder.state === 'recording') {
            stopVoiceRecognition();
          }
        }, 10000);
      })
      .catch(function (err) {
        var msg = 'Une erreur est survenue.';
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
          msg = 'L\'acces au microphone a ete refuse. Veuillez autoriser le micro dans les parametres de votre navigateur.';
        }
        var errorText = voiceModalEl.querySelector('#voice-error-text');
        if (errorText) errorText.textContent = msg;
        showVoiceState('error');
      });
  }

  function stopVoiceRecognition() {
    voiceIsListening = false;
    clearTimeout(voiceAutoStopTimer);
    if (voiceMediaRecorder && voiceMediaRecorder.state === 'recording') {
      voiceMediaRecorder.stop();
    }
  }

  function sendVoiceToAPI(audioBlob) {
    var formData = new FormData();
    var ext = 'webm';
    var mime = audioBlob.type || '';
    if (mime.indexOf('mp4') !== -1 || mime.indexOf('m4a') !== -1) ext = 'mp4';
    else if (mime.indexOf('ogg') !== -1) ext = 'ogg';
    formData.append('audio', audioBlob, 'voice.' + ext);

    var voiceHeaders = {};
    if (GROQ_KEY) voiceHeaders['x-groq-key'] = GROQ_KEY;

    fetch(API_URL + '/voice-parse', {
      method: 'POST',
      headers: voiceHeaders,
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success && (data.brand || data.model)) {
          // Backend AI returned structured data
          var transcriptEl = voiceModalEl.querySelector('#voice-transcript');
          if (transcriptEl) transcriptEl.textContent = data.text || '';
          navigateFromVoice(data.brand, data.model, data.year, data.generation);
        } else if (data.success && data.text) {
          // Fallback: backend returned text only (LLM failed)
          var transcriptEl2 = voiceModalEl.querySelector('#voice-transcript');
          if (transcriptEl2) transcriptEl2.textContent = data.text;
          var errorText = voiceModalEl.querySelector('#voice-error-text');
          if (errorText) errorText.textContent = 'Nous n\'avons pas pu identifier le vehicule. Reessayez en disant par exemple "Megane 3" ou "Toyota Corolla 2012".';
          showVoiceState('error');
        } else {
          var errorText2 = voiceModalEl.querySelector('#voice-error-text');
          if (errorText2) errorText2.textContent = data.message || 'Nous n\'avons pas pu comprendre votre demande.';
          showVoiceState('error');
        }
      })
      .catch(function () {
        var errorText = voiceModalEl.querySelector('#voice-error-text');
        if (errorText) errorText.textContent = 'Erreur de connexion. Veuillez reessayer.';
        showVoiceState('error');
      });
  }

  // Navigate using structured data from backend AI (brand, model, year, generation)
  function navigateFromVoice(brand, model, year, generation) {
    // Load navigation data to resolve model with generation suffix
    loadQuoteNavigation(function (navData) {
      var matchedBrand = brand ? brand.toUpperCase() : null;
      var matchedModel = null;
      var modelsSource = (navData && navData.models) || state.navigation;
      var imagesSource = (navData && navData.images) || state.images || {};

      if (model && modelsSource) {
        var modelUpper = model.toUpperCase();

        // Find the brand's models list
        var brandsToSearch = matchedBrand ? [matchedBrand] : Object.keys(modelsSource);
        var candidates = [];

        for (var bi = 0; bi < brandsToSearch.length; bi++) {
          var bModels = modelsSource[brandsToSearch[bi]];
          if (!bModels) continue;
          for (var mi = 0; mi < bModels.length; mi++) {
            var m = bModels[mi];
            var mName = (m.name || m).toUpperCase();
            var mBase = mName.replace(/\s+\d+$/, '').trim();
            if (mBase === modelUpper || mName === modelUpper) {
              candidates.push({
                brand: brandsToSearch[bi],
                model: mName,
                yearStart: m.yearStart || 0,
                yearEnd: m.yearEnd || 9999,
                yearsDisplay: m.yearsDisplay || ((m.yearStart || '?') + '-' + (m.yearEnd || '?')),
                gen: parseInt(mName.replace(mBase, '').trim()) || 0
              });
            }
          }
        }

        if (candidates.length > 0) {
          // If generation specified, find exact match
          if (generation) {
            for (var gi = 0; gi < candidates.length; gi++) {
              if (candidates[gi].gen === generation) {
                matchedModel = candidates[gi].model;
                if (!matchedBrand) matchedBrand = candidates[gi].brand;
                break;
              }
            }
          }

          // If year specified, find all matching candidates
          var yearMatches = [];
          if (!matchedModel && year) {
            for (var yi = 0; yi < candidates.length; yi++) {
              if (year >= candidates[yi].yearStart && year <= candidates[yi].yearEnd) {
                yearMatches.push(candidates[yi]);
              }
            }
            // Only 1 match → use it directly
            if (yearMatches.length === 1) {
              matchedModel = yearMatches[0].model;
              if (!matchedBrand) matchedBrand = yearMatches[0].brand;
            }
          }

          // MULTIPLE year matches → show choice popup
          if (!matchedModel && yearMatches.length > 1) {
            if (!matchedBrand) matchedBrand = yearMatches[0].brand;
            showVoiceChoices(matchedBrand, yearMatches, imagesSource);
            return;
          }

          // No year matches but multiple candidates → show all as choices
          if (!matchedModel && candidates.length > 1) {
            if (!matchedBrand) matchedBrand = candidates[0].brand;
            showVoiceChoices(matchedBrand, candidates, imagesSource);
            return;
          }

          // Single candidate fallback
          if (!matchedModel && candidates.length === 1) {
            matchedModel = candidates[0].model;
            if (!matchedBrand) matchedBrand = candidates[0].brand;
          }
        }
      }

      // Show result and navigate
      if (matchedBrand) {
        var resultText = matchedBrand;
        if (matchedModel) resultText += ' | ' + matchedModel;
        if (year) resultText += ' | ' + year;

        var resultEl = voiceModalEl.querySelector('#voice-result-text');
        if (resultEl) resultEl.textContent = resultText;
        showVoiceState('result');

        setTimeout(function () {
          closeVoiceModal();
          if (matchedModel) {
            goToModel(matchedBrand, matchedModel);
          } else {
            goToBrand(matchedBrand);
          }
        }, 1500);
      } else {
        var errorText = voiceModalEl.querySelector('#voice-error-text');
        if (errorText) errorText.textContent = 'Vehicule non trouve dans notre catalogue. Reessayez.';
        showVoiceState('error');
      }
    });
  }

  // ============================================
  // HELPERS
  // ============================================

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function escapeAttr(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function formatPrice(price) {
    var num = parseFloat(price);
    if (isNaN(num)) return price;
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(context, args); }, delay);
    };
  }

  var MANUFACTURERS = ['TYC', 'DEPO', 'VALEO', 'HELLA', 'MAGNETI MARELLI', 'BOSCH', 'ALKAR', 'PRASCO', 'VAN WEZEL', 'JOHNS', 'BLIC', 'ABAKUS', 'DIEDERICHS', 'MARS', 'ULO', 'HAGUS', 'AYFAR', 'EQUAL QUALITY'];

  function extractManufacturer(title) {
    if (!title) return null;
    var upper = title.toUpperCase();
    for (var i = 0; i < MANUFACTURERS.length; i++) {
      if (upper.indexOf(MANUFACTURERS[i]) !== -1) return MANUFACTURERS[i];
    }
    return null;
  }

  function findModelInfo(brand, model) {
    if (!state.navigation || !state.navigation[brand]) return null;
    var models = state.navigation[brand];
    for (var i = 0; i < models.length; i++) {
      if (models[i].name === model) return models[i];
    }
    return null;
  }

  // ============================================
  // INIT
  // ============================================

  function init() {
    // Parse URL for initial state
    var params = parseUrl();
    if (params.model && params.brand) {
      state.view = 'products';
      state.brand = params.brand;
      state.model = params.model;
    } else if (params.brand) {
      state.view = 'models';
      state.brand = params.brand;
    }

    // Check manifest for cache invalidation FIRST, then load data
    checkManifest().then(function () {
      return Promise.all([loadNavigation(), loadLogos()]);
    })
      .then(function () {
        render();

        // If we need models or products, load them
        if (state.view === 'models' && state.brand) {
          loadModels(state.brand);
        } else if (state.view === 'products' && state.brand && state.model) {
          loadModels(state.brand).then(function () {
            loadProducts(state.brand, state.model);
          });
        }
      })
      .catch(function (err) {
        if (loading) loading.style.display = 'none';
        if (root) {
          root.style.display = 'block';
          root.innerHTML = renderError('Impossible de charger le catalogue. Verifiez la connexion.');
          bindEvents();
        }
      });
  }


  // Listen for reset event from sidebar (Pieces Carrosserie tab)
  document.addEventListener("catalogue:reset", function() {
    goHome();
  });
  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ============================================
  // PIECE SEARCH (live suggestions from Shopify)
  // ============================================

  function initPieceSearch() {
    var input = document.getElementById('cat-piece-search');
    var box = document.getElementById('cat-piece-suggestions');
    if (!input || !box) return;

    var timer = null;
    input.addEventListener('input', function() {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.classList.remove('active'); box.innerHTML = ''; return; }
      timer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!prods.length) {
              box.innerHTML = '<div class="sb-empty">Aucun r\u00e9sultat pour \u00ab' + q + '\u00bb</div>';
              box.classList.add('active');
              return;
            }
            var h = '';
            for (var i = 0; i < prods.length; i++) {
              var p = prods[i];
              var img = p.image || p.featured_image || '';
              if (img && img.indexOf('//') === 0) img = 'https:' + img;
              var thumb = img ? (img.indexOf('?') > -1 ? img + '&width=100' : img + '?width=100') : '';
              var price = p.price ? parseFloat(p.price).toFixed(0) + ' DH' : '';
              h += '<a href="' + p.url + '" class="sb-item">';
              h += '<div class="sb-item__img">';
              if (thumb) h += '<img src="' + thumb + '" alt="" width="48" height="48">';
              else h += '<span class="sb-item__noimg">?</span>';
              h += '</div>';
              h += '<div class="sb-item__info">';
              h += '<div class="sb-item__name">' + (p.title || '') + '</div>';
              if (price) h += '<div class="sb-item__price">' + price + '</div>';
              h += '</div>';
              h += '</a>';
            }
            h += '<a href="/search?q=' + encodeURIComponent(q) + '" class="sb-viewall">Voir tous les r\u00e9sultats &rarr;</a>';
            box.innerHTML = h;
            box.classList.add('active');
          }).catch(function() { box.classList.remove('active'); });
      }, 250);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (q.length >= 2) { box.classList.remove('active'); window.location.href = '/search?q=' + encodeURIComponent(q); }
      }
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.cat-smartbar__search-pill')) { box.classList.remove('active'); }
    });
  }

  // MOBILE SEARCH (overlay with live suggestions)
  function initMobileSearch() {
    var overlay = document.getElementById('csm-search-overlay');
    var input = document.getElementById('csm-search-input');
    var results = document.getElementById('csm-search-results');
    if (!overlay || !input) return;

    var timer = null;
    input.addEventListener('input', function() {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!prods.length) {
              results.innerHTML = '<div class="sb-empty">Aucun r\u00e9sultat pour \u00ab' + q + '\u00bb</div>';
              return;
            }
            var h = '';
            for (var i = 0; i < prods.length; i++) {
              var p = prods[i];
              var img = p.image || p.featured_image || '';
              if (img && img.indexOf('//') === 0) img = 'https:' + img;
              var thumb = img ? (img.indexOf('?') > -1 ? img + '&width=100' : img + '?width=100') : '';
              var price = p.price ? parseFloat(p.price).toFixed(0) + ' DH' : '';
              h += '<a href="' + p.url + '" class="sb-item">';
              h += '<div class="sb-item__img">';
              if (thumb) h += '<img src="' + thumb + '" alt="" width="48" height="48">';
              else h += '<span class="sb-item__noimg">?</span>';
              h += '</div>';
              h += '<div class="sb-item__info">';
              h += '<div class="sb-item__name">' + (p.title || '') + '</div>';
              if (price) h += '<div class="sb-item__price">' + price + '</div>';
              h += '</div>';
              h += '</a>';
            }
            h += '<a href="/search?q=' + encodeURIComponent(q) + '" class="sb-viewall">Voir tous les r\u00e9sultats &rarr;</a>';
            results.innerHTML = h;
          });
      }, 250);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (q.length >= 2) { window.location.href = '/search?q=' + encodeURIComponent(q); }
      }
    });
  }

  // ============================================
  // AI POPUP
  // ============================================

  var aiPopupHTML = '<div class="cat-ai-overlay" id="cat-ai-overlay"></div>'
    + '<div class="cat-ai-popup" id="cat-ai-popup">'
    + '<div class="cat-ai-popup__head">'
    + '<div class="cat-ai-popup__head-icon"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="12" cy="10" r="4"/><path d="M6 20c0-3.3 2.7-6 6-6s6 2.7 6 6"/><path d="M15.5 4.5l1 1M8.5 4.5l-1 1M12 2v1.5"/></svg></div>'
    + '<div class="cat-ai-popup__head-info"><h4>RT Assistant</h4><span>Trouvez la bonne pi\u00e8ce</span></div>'
    + '<button class="cat-ai-popup__close" id="cat-ai-close">&times;</button>'
    + '</div>'
    + '<div class="cat-ai-popup__msgs" id="cat-ai-msgs">'
    + '<div class="cat-ai-msg cat-ai-msg--bot">Salam! \uD83D\uDC4B Gouliya chnou katqelleb 3lih, wella gouliya marque w model dyal tomobilek bach nwerrik les pi\u00e8ces.</div>'
    + '</div>'
    + '<div class="cat-ai-popup__chips" id="cat-ai-chips">'
    + '<span class="cat-ai-chip" data-q="phare avant">\uD83D\uDCA1 Phares</span>'
    + '<span class="cat-ai-chip" data-q="retroviseur">\uD83D\uDD0D Retroviseurs</span>'
    + '<span class="cat-ai-chip" data-q="pare choc avant">\uD83D\uDEE1\uFE0F Pare-chocs</span>'
    + '<span class="cat-ai-chip" data-q="feu arriere">\uD83D\uDD34 Feux</span>'
    + '</div>'
    + '<div class="cat-ai-popup__footer">'
    + '<input type="text" class="cat-ai-popup__input" id="cat-ai-input" placeholder="Kifach n9der n3awnek...">'
    + '<button class="cat-ai-popup__send" id="cat-ai-send"><svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg></button>'
    + '</div>'
    + '</div>';

  function initAIPopup() {
    // Insert popup HTML into body
    var wrapper = document.createElement('div');
    wrapper.innerHTML = aiPopupHTML;
    while (wrapper.firstChild) document.body.appendChild(wrapper.firstChild);

    var popup = document.getElementById('cat-ai-popup');
    var overlay = document.getElementById('cat-ai-overlay');
    var closeBtn = document.getElementById('cat-ai-close');
    var input = document.getElementById('cat-ai-input');
    var sendBtn = document.getElementById('cat-ai-send');
    var msgs = document.getElementById('cat-ai-msgs');
    var chips = document.getElementById('cat-ai-chips');

    function openAI() { popup.classList.add('active'); overlay.classList.add('active'); setTimeout(function() { input.focus(); }, 300); }
    function closeAI() { popup.classList.remove('active'); overlay.classList.remove('active'); }

    // Listen for open button clicks via delegation
    document.addEventListener('click', function(e) {
      /* voice-search handled by main event delegation */
    });
    if (closeBtn) closeBtn.addEventListener('click', closeAI);
    if (overlay) overlay.addEventListener('click', closeAI);

    function addMsg(text, type) {
      var d = document.createElement('div');
      d.className = 'cat-ai-msg cat-ai-msg--' + type;
      d.innerHTML = text;
      msgs.appendChild(d);
      msgs.scrollTop = msgs.scrollHeight;
    }

    function aiSearch(query) {
      addMsg(query, 'user');
      addMsg('<span style="opacity:0.5">Kanqelleb lik...</span>', 'bot');
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var last = msgs.lastChild;
          if (last && last.innerHTML.indexOf('Kanqelleb') > -1) msgs.removeChild(last);
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length) {
            addMsg('Hana lqit lik ' + products.length + ' produit(s) \uD83D\uDC47', 'bot');
            for (var i = 0; i < products.length; i++) {
              var p = products[i];
              var pImg = p.image || p.featured_image || '';
              if (pImg && pImg.indexOf('//') === 0) pImg = 'https:' + pImg;
              var pPrice = p.price ? parseFloat(p.price).toFixed(0) + ' DH' : '';
              var d = document.createElement('div');
              d.className = 'cat-ai-msg cat-ai-msg--product';
              d.innerHTML = '<a href="' + p.url + '">'
                + (pImg ? '<img src="' + pImg + '" alt="">' : '')
                + '<div><div class="cat-ai-p-name">' + (p.title || '') + '</div>'
                + (pPrice ? '<div class="cat-ai-p-price">' + pPrice + '</div>' : '')
                + '</div></a>';
              msgs.appendChild(d);
            }
            msgs.scrollTop = msgs.scrollHeight;
            addMsg('Bghiti chi haja khra?', 'bot');
          } else {
            addMsg('Ma lqitch "' + query + '" \uD83D\uDE15 Jerreb kelma khra.', 'bot');
          }
        }).catch(function() {
          var last = msgs.lastChild;
          if (last && last.innerHTML.indexOf('Kanqelleb') > -1) msgs.removeChild(last);
          addMsg('Mouchkil f connexion.', 'bot');
        });
    }

    function sendAI() {
      var q = input.value.trim();
      if (!q) return;
      input.value = '';
      if (chips) chips.style.display = 'none';
      aiSearch(q);
    }

    if (sendBtn) sendBtn.addEventListener('click', sendAI);
    if (input) input.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); sendAI(); } });
    if (chips) chips.addEventListener('click', function(e) {
      var chip = e.target.closest('.cat-ai-chip');
      if (chip) { input.value = ''; chips.style.display = 'none'; aiSearch(chip.getAttribute('data-q')); }
    });
  }

  // Auto-init piece search + AI popup after each render
  var _origRender = render;
  render = function() {
    _origRender.apply(this, arguments);
    setTimeout(function() { initPieceSearch();
          initMobileSearch(); }, 50);
  };

  // Init AI popup once
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAIPopup);
  } else {
    initAIPopup();
  }

})();
